/* ============================================
   🐼 DodoCalin.fr — Interactions & Animations
   ============================================ */

document.addEventListener('DOMContentLoaded', () => {
  initScrollReveal();
  initMobileMenu();
  initBackToTop();
  initStockCounter();
  initNavbarScroll();
  initSmoothScroll();
  initBuyButton();
  initScrollProgress();
  initDreamParticles();
  initAnimatedCounters();
  initTimeGreeting();
  initSocialProof();
  initStickyCart();
  initHeroTilt();
  initCookieConsent();
});

/* ---------- Scroll Reveal (Intersection Observer) ---------- */
function initScrollReveal() {
  const reveals = document.querySelectorAll('.reveal');

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        // Stagger animation for grid children
        const delay = entry.target.closest('.benefits-grid, .testimonials-grid, .faq-list')
          ? Array.from(entry.target.parentElement.children).indexOf(entry.target) * 100
          : 0;

        setTimeout(() => {
          entry.target.classList.add('visible');
        }, delay);

        observer.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.15,
    rootMargin: '0px 0px -60px 0px'
  });

  reveals.forEach(el => observer.observe(el));
}

/* ---------- Mobile Menu ---------- */
function initMobileMenu() {
  const toggle = document.getElementById('menuToggle');
  const navLinks = document.getElementById('navLinks');
  const overlay = document.getElementById('menuOverlay');

  if (!toggle || !navLinks) return;

  function closeMenu() {
    toggle.classList.remove('active');
    navLinks.classList.remove('active');
    if (overlay) overlay.classList.remove('active');
  }

  function openMenu() {
    toggle.classList.add('active');
    navLinks.classList.add('active');
    if (overlay) overlay.classList.add('active');
  }

  toggle.addEventListener('click', () => {
    if (navLinks.classList.contains('active')) {
      closeMenu();
    } else {
      openMenu();
    }
  });

  navLinks.querySelectorAll('a').forEach(link => {
    link.addEventListener('click', closeMenu);
  });

  if (overlay) {
    overlay.addEventListener('click', closeMenu);
  }
}

/* ---------- Navbar Scroll Effect ---------- */
function initNavbarScroll() {
  const navbar = document.getElementById('navbar');
  if (!navbar) return;

  window.addEventListener('scroll', () => {
    if (window.pageYOffset > 100) {
      navbar.style.boxShadow = '0 2px 20px rgba(45, 53, 97, 0.08)';
    } else {
      navbar.style.boxShadow = 'none';
    }
  }, { passive: true });
}

/* ---------- Back to Top Button ---------- */
function initBackToTop() {
  const btn = document.getElementById('backToTop');
  if (!btn) return;

  window.addEventListener('scroll', () => {
    if (window.pageYOffset > 500) {
      btn.classList.add('show');
    } else {
      btn.classList.remove('show');
    }
  }, { passive: true });

  btn.addEventListener('click', () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });
}

/* ---------- Stock Counter (Urgency Effect) ---------- */
function initStockCounter() {
  const counter = document.getElementById('stockCount');
  if (!counter) return;

  let stock = 47;

  setInterval(() => {
    if (stock > 12 && Math.random() > 0.7) {
      stock--;
      counter.textContent = stock;
      counter.style.transform = 'scale(1.2)';
      setTimeout(() => {
        counter.style.transform = 'scale(1)';
      }, 300);
    }
  }, 30000);
}

/* ---------- FAQ Accordion ---------- */
function toggleFaq(element) {
  const item = element.parentElement;

  document.querySelectorAll('.faq-item.active').forEach(other => {
    if (other !== item) {
      other.classList.remove('active');
      const btn = other.querySelector('.faq-question');
      if (btn) btn.setAttribute('aria-expanded', 'false');
    }
  });

  const isNowActive = item.classList.toggle('active');
  element.setAttribute('aria-expanded', isNowActive ? 'true' : 'false');
}

/* ---------- Product Gallery ---------- */
function changeProductImage(thumb) {
  const mainImg = document.getElementById('mainProductImg');
  if (!mainImg || !thumb) return;

  mainImg.style.opacity = '0';
  mainImg.style.transform = 'scale(0.98)';

  setTimeout(() => {
    mainImg.src = thumb.src;
    mainImg.alt = thumb.alt;
    mainImg.style.opacity = '1';
    mainImg.style.transform = 'scale(1)';
  }, 200);

  document.querySelectorAll('.product-thumbs img').forEach(t => t.classList.remove('active'));
  thumb.classList.add('active');
}

/* Newsletter is handled natively by Shopify {% form 'customer' %} in newsletter.liquid */

/* ---------- Smooth Scroll Enhancement ---------- */
function initSmoothScroll() {
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      const href = this.getAttribute('href');
      if (href === '#') return;
      const target = document.querySelector(href);
      if (target) {
        e.preventDefault();
        const offset = 80;
        const elementPosition = target.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - offset;

        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      }
    });
  });
}

/* ---------- Buy Button Effect ---------- */
function initBuyButton() {
  const buyBtn = document.getElementById('buyBtn');
  if (!buyBtn) return;

  // Read variant ID from data attribute (set in Liquid) or fallback
  const VARIANT_ID = buyBtn.dataset.variantId || '56383097799036';

  function handleBuy(e) {
    e.preventDefault();
    const btn = e.currentTarget;
    const originalHTML = btn.innerHTML;

    btn.style.transform = 'scale(0.95)';
    setTimeout(() => { btn.style.transform = 'scale(1)'; }, 150);

    btn.innerHTML = '⏳ Ajout au panier...';
    btn.style.pointerEvents = 'none';

    // Use Shopify Cart API
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(VARIANT_ID), quantity: 1 }] })
    })
    .then(response => {
      if (!response.ok) throw new Error('Cart error');
      return response.json();
    })
    .then(() => {
      btn.innerHTML = '✅ Ajouté ! Redirection...';
      btn.style.background = 'linear-gradient(135deg, #4CAF50, #45a049)';
      btn.style.color = '#fff';

      setTimeout(() => {
        window.location.href = '/checkout';
      }, 600);
    })
    .catch(() => {
      // Fallback: redirect directly to cart checkout URL
      window.location.href = '/cart/' + VARIANT_ID + ':1';
    });
  }

  buyBtn.addEventListener('click', handleBuy);

  // Also bind sticky buy button
  const stickyBtn = document.getElementById('stickyBuyBtn');
  if (stickyBtn) {
    stickyBtn.addEventListener('click', handleBuy);
  }

  // Product image transition
  const mainImg = document.getElementById('mainProductImg');
  if (mainImg) {
    mainImg.style.transition = 'opacity 0.3s ease, transform 0.3s ease';
  }
}

/* ============================================
   ✨ PREMIUM EXPERIENCE FEATURES
   ============================================ */

/* ---------- Scroll Progress Bar ---------- */
function initScrollProgress() {
  const bar = document.getElementById('scrollProgress');
  if (!bar) return;

  window.addEventListener('scroll', () => {
    const scrollTop = window.pageYOffset;
    const docHeight = document.documentElement.scrollHeight - window.innerHeight;
    const progress = (scrollTop / docHeight) * 100;
    bar.style.width = progress + '%';
  }, { passive: true });
}

/* ---------- Floating Dream Particles ---------- */
function initDreamParticles() {
  const container = document.getElementById('dreamParticles');
  if (!container) return;

  const emojis = ['✨', '🌙', '💫', '⭐', '💤', '🌟'];

  function createParticle() {
    const particle = document.createElement('span');
    particle.className = 'dream-particle';
    particle.textContent = emojis[Math.floor(Math.random() * emojis.length)];
    particle.style.left = Math.random() * 100 + '%';
    particle.style.fontSize = (0.8 + Math.random() * 1.2) + 'rem';
    particle.style.animationDuration = (8 + Math.random() * 12) + 's';
    particle.style.animationDelay = Math.random() * 2 + 's';
    container.appendChild(particle);

    // Remove after animation
    setTimeout(() => {
      particle.remove();
    }, 22000);
  }

  // Create initial batch
  for (let i = 0; i < 6; i++) {
    setTimeout(createParticle, i * 800);
  }

  // Continuously spawn
  setInterval(createParticle, 3000);
}

/* ---------- Animated Stat Counters ---------- */
function initAnimatedCounters() {
  const stats = document.querySelectorAll('[data-count]');
  if (!stats.length) return;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        animateCounter(entry.target);
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.5 });

  stats.forEach(stat => observer.observe(stat));
}

function animateCounter(el) {
  const target = parseFloat(el.dataset.count);
  const suffix = el.dataset.suffix || '';
  const format = el.dataset.format;
  const isFloat = target % 1 !== 0;
  const duration = 2000;
  const startTime = performance.now();

  function update(currentTime) {
    const elapsed = currentTime - startTime;
    const progress = Math.min(elapsed / duration, 1);
    // Ease out cubic
    const eased = 1 - Math.pow(1 - progress, 3);
    const current = eased * target;

    let display;
    if (isFloat) {
      display = current.toFixed(1);
    } else {
      const rounded = Math.round(current);
      if (format === 'space' && rounded >= 1000) {
        display = rounded.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
      } else {
        display = rounded.toString();
      }
    }

    el.textContent = display + suffix;

    if (progress < 1) {
      requestAnimationFrame(update);
    }
  }

  requestAnimationFrame(update);
}

/* ---------- Time-based Personalized Greeting ---------- */
function initTimeGreeting() {
  const el = document.getElementById('heroGreeting');
  if (!el) return;

  const hour = new Date().getHours();
  let greeting;

  if (hour >= 5 && hour < 12) {
    greeting = 'Bien dormi ? Marque Française de Bien-Être';
  } else if (hour >= 12 && hour < 18) {
    greeting = 'Préparez vos nuits — Marque Française de Bien-Être';
  } else if (hour >= 18 && hour < 22) {
    greeting = 'Bonne soirée — Marque Française de Bien-Être';
  } else {
    greeting = 'Besoin de sommeil ? Marque Française de Bien-Être';
  }

  el.textContent = greeting;
}

/* ---------- Social Proof Toasts ---------- */
function initSocialProof() {
  const toast = document.getElementById('socialProofToast');
  if (!toast) return;

  const people = [
    { name: 'Marie L.', city: 'Paris' },
    { name: 'Thomas B.', city: 'Bruxelles' },
    { name: 'Sophie D.', city: 'Lyon' },
    { name: 'Karim A.', city: 'Lille' },
    { name: 'Julie M.', city: 'Marseille' },
    { name: 'Lucas R.', city: 'Bordeaux' },
    { name: 'Emma V.', city: 'Nantes' },
    { name: 'Hugo P.', city: 'Toulouse' },
    { name: 'Léa F.', city: 'Strasbourg' },
    { name: 'Nathan C.', city: 'Nice' },
  ];

  const times = [
    'il y a 2 minutes',
    'il y a 5 minutes',
    'il y a 12 minutes',
    'il y a 23 minutes',
    'il y a 1 heure',
  ];

  let index = 0;
  let toastTimeout;

  function showToast() {
    const person = people[index % people.length];
    const time = times[Math.floor(Math.random() * times.length)];

    toast.querySelector('.toast-name').textContent = person.name + ' de ' + person.city;
    toast.querySelector('.toast-time').textContent = time;

    toast.classList.remove('show');
    // Force reflow for re-animation
    void toast.offsetWidth;
    toast.classList.add('show');

    index++;
    toastTimeout = setTimeout(showToast, 25000 + Math.random() * 15000);
  }

  // First toast after 8 seconds
  toastTimeout = setTimeout(showToast, 8000);
}

/* ---------- Sticky Add-to-Cart Bar ---------- */
function initStickyCart() {
  const stickyCart = document.getElementById('stickyCart');
  const productSection = document.getElementById('product');
  const backToTop = document.getElementById('backToTop');
  if (!stickyCart || !productSection) return;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      // Show sticky bar when product section is no longer visible
      if (!entry.isIntersecting && window.pageYOffset > productSection.offsetTop) {
        stickyCart.classList.add('show');
        if (backToTop) backToTop.classList.add('has-sticky');
      } else {
        stickyCart.classList.remove('show');
        if (backToTop) backToTop.classList.remove('has-sticky');
      }
    });
  }, { threshold: 0 });

  observer.observe(productSection);
}

/* ---------- Hero Image Subtle Tilt on Mouse Move ---------- */
function initHeroTilt() {
  const wrapper = document.getElementById('heroImageWrapper');
  if (!wrapper) return;

  const hero = document.querySelector('.hero');
  if (!hero) return;

  hero.addEventListener('mousemove', (e) => {
    const rect = hero.getBoundingClientRect();
    const x = (e.clientX - rect.left) / rect.width - 0.5;
    const y = (e.clientY - rect.top) / rect.height - 0.5;

    wrapper.style.transform = `perspective(1000px) rotateY(${x * 8}deg) rotateX(${-y * 8}deg)`;
  });

  hero.addEventListener('mouseleave', () => {
    wrapper.style.transform = 'perspective(1000px) rotateY(0deg) rotateX(0deg)';
    wrapper.style.transition = 'transform 0.6s ease';
    setTimeout(() => {
      wrapper.style.transition = '';
    }, 600);
  });
}

/* ---------- RGPD Cookie Consent ---------- */
function initCookieConsent() {
  const banner = document.getElementById('cookieBanner');
  if (!banner) return;

  // Already consented — don't show
  if (localStorage.getItem('dodocalin_cookies')) return;

  // Show banner after short delay
  setTimeout(() => {
    banner.classList.add('show');
    banner.setAttribute('aria-hidden', 'false');
  }, 1500);

  const acceptBtn = document.getElementById('cookieAccept');
  const rejectBtn = document.getElementById('cookieReject');

  function closeBanner(choice) {
    localStorage.setItem('dodocalin_cookies', choice);
    banner.classList.remove('show');
    banner.setAttribute('aria-hidden', 'true');
  }

  if (acceptBtn) {
    acceptBtn.addEventListener('click', () => closeBanner('accepted'));
  }

  if (rejectBtn) {
    rejectBtn.addEventListener('click', () => closeBanner('rejected'));
  }
}
